/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../sass/app.scss';
// axios/CSRF 같은 framework bootstrap 만 유지한다.
// Font Awesome icons and jQuery legacy bridge are split into separate entries.
import './bootstrap';
import './iife-pages/public-content-inline-editor.js';
import './introduce-education.js';
import './iife-pages/home-page-setting-card-save.js';
// import datatable from 'datatables';
// require('datatables.net');

var appPageModulesStarted = false;

function bootAppPageModules() {
    if (appPageModulesStarted) return;
    appPageModulesStarted = true;

    // fetch 를 값으로 미리 bind 하지 않는다 — **호출할 때의** window.fetch 로 넘긴다.
    // common.js 가 지점 이동 대기용으로 fetch 를 감싸는데(skmInstallFetchInFlightCounter), 미리 bind 하면
    // 로드 순서에 따라 감싸기 전 원본을 붙잡아 그 대기를 우회한다 — 빌드 결과에서는 이 파일이 head 의
    // 일반 스크립트라 DOMContentLoaded 뒤에 붙잡아 괜찮지만, vite 개발 서버에서는 module 로 먼저 실행된다
    // (Codex F-01, PR #4901). 그러면 홈페이지 설정 저장이 지점 이동과 경합한다.
    var fetchRef = window.fetch ? function () { return window.fetch.apply(window, arguments); } : window.fetch;
    if (typeof window.SkmPublicContentEditor === 'function') {
        window.SkmPublicContentEditor({
            document: window.document,
            window,
            fetch: fetchRef,
        }).init();
    }
    if (typeof window.SkmHomePageSettingCardSave === 'function') {
        window.SkmHomePageSettingCardSave({
            document: window.document,
            window,
            fetch: fetchRef,
            FormData: window.FormData,
        }).init();
    }
}

if (window.document.readyState === 'loading') {
    window.document.addEventListener('DOMContentLoaded', bootAppPageModules, { once: true });
} else {
    bootAppPageModules();
}


/*
 * Vue 2 scaffolding 은 Laravel 5.5 시대 잔재로, 본 코드베이스는 Vue 사용처 0건.
 * Vue 2 + vue-template-compiler dependency 와 함께 ExampleComponent.vue 도 제거됨.
 * (PR-B, 2026-05-13 — Laravel 13 정리 시리즈)
 */
